import { useEffect, useState } from 'react';

export default function RecipeVersionsTab() {
    const [dishes, setDishes] = useState([]);
    const [selectedDishId, setSelectedDishId] = useState(null);
    const [versions, setVersions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const load = async () => {
            try {
                const resp = await fetch('/api/inventory/dishes');
                if (resp.ok) {
                    const data = await resp.json();
                    setDishes(data || []);
                }
            } catch (e) {
                console.error('Erreur chargement plats', e);
            }
        };
        load();
    }, []);

    useEffect(() => {
        if (!selectedDishId) return;
        const loadVersions = async () => {
            setLoading(true);
            try {
                const resp = await fetch(`/api/dishes/${selectedDishId}/recipe/versions`);
                if (resp.ok) {
                    const data = await resp.json();
                    setVersions(data.data || []);
                }
            } catch (e) {
                console.error('Erreur chargement versions', e);
            } finally {
                setLoading(false);
            }
        };
        loadVersions();
    }, [selectedDishId]);

    return (
        <div>
            <h2 className="text-xl font-semibold">Versions des recettes</h2>

            <div className="mt-4">
                <label className="block text-sm font-semibold">Plat</label>
                <select className="mt-2 border rounded px-2 py-1 w-full" value={selectedDishId || ''} onChange={(e) => setSelectedDishId(e.target.value)}>
                    <option value="">Sélectionner un plat...</option>
                    {dishes.map(d => (
                        <option key={d.id} value={d.id}>{d.name}</option>
                    ))}
                </select>
            </div>

            <div className="mt-4">
                {loading && <div>Chargement...</div>}
                {!loading && versions.length === 0 && <div className="text-sm text-gray-500">Aucune version trouvée.</div>}
                {!loading && versions.length > 0 && (
                    <ul className="mt-2 space-y-2">
                        {versions.map(v => (
                            <li key={v.id} className="p-3 rounded border bg-white">
                                <div className="flex justify-between">
                                    <div>
                                        <div className="font-semibold">Version {v.version}</div>
                                        <div className="text-sm text-gray-600">Créée le {new Date(v.created_at).toLocaleString()}</div>
                                    </div>
                                    <div className="text-sm text-gray-500">Par: {v.created_by || '—'}</div>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
